module.exports = __webpack_public_path__ + "img/goods12-1.49522c69.jpg";